import { render, staticRenderFns } from "./BrandCard.vue?vue&type=template&id=b2497050&"
import script from "./BrandCard.vue?vue&type=script&lang=js&"
export * from "./BrandCard.vue?vue&type=script&lang=js&"
import style0 from "./BrandCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports